<template>
  <nav
    class="pcm-b-site-links"
    :class="`pcm-b-site-links-${variant}`"
    aria-label="网站地址"
  >
    <a
      v-for="link in links"
      :key="link.key"
      class="pcm-b-site-link"
      :href="link.url"
      target="_blank"
      rel="noopener noreferrer"
      @click.stop="trackAddress(link, $event)"
    >
      <span class="pcm-b-site-label">{{ link.label }}</span>
      <span class="pcm-b-site-url">{{ link.url }}</span>
    </a>
  </nav>
</template>

<script>
import { landingPageClick } from "@/utils/eventTracker";

const SITE_LINKS = [
  { key: "domestic", label: "国内地址", url: "https://hgdhy2.com" },
  { key: "latest", label: "最新地址", url: "https://etqsy.com" },
  { key: "official", label: "官网地址", url: "https://huangguo.com" },
  { key: "permanent", label: "永久发布页", url: "https://hgdj.fm" }
];

export default {
  props: {
    variant: { type: String, default: "mobile" },
    version: { type: String, default: "B" }
  },
  data() {
    return { links: SITE_LINKS };
  },
  methods: {
    trackAddress(link, event) {
      landingPageClick(this, {
        tab_key: `site_${link.key}`,
        tab_name: link.label,
        click_coordinates_x: event.clientX,
        click_coordinates_y: event.clientY
      });
    }
  }
};
</script>

<style scoped>
.pcm-b-site-links {
  display: grid;
  box-sizing: border-box;
  pointer-events: auto;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}
.pcm-b-site-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid #f9a129;
  background: linear-gradient(
      110deg,
      rgba(255, 148, 48, 0.13),
      rgba(255, 148, 48, 0.035) 52%,
      rgba(255, 255, 255, 0.024)
    ),
    rgba(17, 17, 20, 0.4);
  -webkit-backdrop-filter: blur(33px);
  backdrop-filter: blur(33px);
  font-family: inherit;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
}
.pcm-b-site-label,
.pcm-b-site-url {
  font-family: inherit;
}
.pcm-b-site-label {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}
.pcm-b-site-url {
  color: #f9a129;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 0.12em;
}
.pcm-b-site-link:hover {
  border-color: #ffdb83;
}
.pcm-b-site-link:focus-visible {
  outline: 2px solid #ffe6a1;
  outline-offset: 3px;
}
.pcm-b-site-links-mobile {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: calc(var(--mb-layout-width) * 0.03482587 - 2px);
}
.pcm-b-site-links-mobile .pcm-b-site-link {
  height: calc(var(--mb-layout-width) * 0.12935323 - 2px);
  gap: calc(var(--mb-layout-width) * 0.00497512);
  border-radius: calc(var(--mb-layout-width) * 0.05970149);
  font-size: calc(var(--mb-layout-width) * 0.03482587);
}
.pcm-b-site-links-mobile .pcm-b-site-label {
  line-height: calc(var(--mb-layout-width) * 0.04975124);
}
.pcm-b-site-links-mobile .pcm-b-site-url {
  line-height: calc(var(--mb-layout-width) * 0.05472637);
}
.pcm-b-site-links-pc {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: calc(min(0.729167vw, 1.296296vh) - 2px);
}
.pcm-b-site-links-pc .pcm-b-site-link {
  height: 100%;
  gap: min(0.208333vw, 0.37037vh);
  border-radius: min(1.25vw, 2.222222vh);
}
.pcm-b-site-links-pc .pcm-b-site-label {
  font-size: min(0.729167vw, 1.296296vh);
  line-height: min(1.041667vw, 1.851852vh);
}
.pcm-b-site-links-pc .pcm-b-site-url {
  font-size: min(0.833333vw, 1.481481vh);
  line-height: min(1.354167vw, 2.407407vh);
}
</style>
